module.exports = __webpack_public_path__ + "static/media/7_4.e7d9fbff.png";